import { Link } from "react-router-dom";
import { RotateCcw, Trophy, Coins, Sparkles, Loader2 } from "lucide-react";

function Stat({ label, value, testId }) {
  return (
    <div className="pz-stat" data-testid={testId}>
      <div className="pz-chip-label">{label}</div>
      <div className="text-lg font-black">{value}</div>
    </div>
  );
}

export function ResultCard({ result, onAgain }) {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center p-5 bg-black/30 backdrop-blur-sm">
      <div className="pz-card max-w-sm w-full text-center pz-rise" data-testid="bp-result-card">
        <div className="pz-kicker">Round over</div>
        {!result ? <Loader2 className="w-8 h-8 animate-spin mx-auto my-8" /> : <>
          <div className="text-6xl font-black tracking-tight mt-1" style={{ fontFamily: "Cabinet Grotesk, Outfit" }} data-testid="bp-final-score">{result.score.toLocaleString()}</div>
          {result.new_best && <div className="inline-flex items-center gap-1 text-xs font-bold text-[#FFB800] mt-1" data-testid="bp-new-best"><Sparkles className="w-3.5 h-3.5" />New personal best</div>}
          <div className="grid grid-cols-3 gap-2 my-5">
            <Stat label="Pops" value={result.pops} testId="bp-stat-pops" />
            <Stat label="Golden" value={result.golden} testId="bp-stat-golden" />
            <Stat label="Best combo" value={`x${result.max_combo}`} testId="bp-stat-combo" />
          </div>
          {result.coins_earned !== undefined && (
            <div className="rounded-2xl bg-[#FFB800]/10 border border-[#FFB800]/30 p-3 mb-4 text-sm" data-testid="bp-coins-earned">
              <div className="flex items-center justify-center gap-1.5 font-black text-[#FFB800]"><Coins className="w-4 h-4" />+{result.coins_earned} coins</div>
              <div className="text-[11px] text-white/60 mt-1">
                {result.coins_today >= result.daily_cap ? "Daily coin limit reached — leaderboards still count." : `${result.coins_today}/${result.daily_cap} coins earned today`}
                {result.rank_all ? ` · All-time rank #${result.rank_all}` : ""}
              </div>
            </div>
          )}
          {result.guest && <p className="text-xs text-white/70 mb-4" data-testid="bp-guest-result"><Link to="/login?next=/playzone/balloon-pop" className="underline text-[#00E5FF]">Sign in</Link> to keep your score and earn coins.</p>}
          {result.error && <p className="text-xs text-[#FF2E88] mb-4" data-testid="bp-result-error">{result.error}</p>}
        </>}
        <button onClick={onAgain} className="pz-btn w-full" data-testid="bp-play-again"><RotateCcw className="w-5 h-5" /> Play again</button>
        <Link to="/playzone#leaderboard" className="text-xs text-white/60 mt-3 inline-flex items-center gap-1 hover:text-white" data-testid="bp-result-leaderboard"><Trophy className="w-3.5 h-3.5" />See leaderboards</Link>
      </div>
    </div>
  );
}
